export default __webpack_public_path__ + "static/media/oscer-pres-mouth-ucler.75f10dcc.svg";